import { useEffect, useRef } from "react";
import { papi } from "./portalApi";

const INTERVAL_MS = 30000;

// Sinal de presenca do Portal: so com pagina visivel e online. Sem fila, sem reenvio, sem cache.
export function usePortalPresence(enabled, onExpired) {
  const expiredRef = useRef(onExpired);
  expiredRef.current = onExpired;

  useEffect(() => {
    if (!enabled) return undefined;
    let timer = null;
    let inflight = false;
    let stopped = false;
    const active = () => document.visibilityState === "visible" && navigator.onLine;
    const pause = () => { if (timer) clearInterval(timer); timer = null; };
    const stop = () => { stopped = true; pause(); };

    const beat = async () => {
      if (stopped || inflight || !active()) return;
      inflight = true;
      try {
        await papi.post("/portal/presence/heartbeat", null, { timeout: 10000 });
      } catch (e) {
        if (e?.response?.status === 401) { stop(); expiredRef.current?.(); }
      } finally { inflight = false; }
    };
    const start = () => { pause(); beat(); timer = setInterval(beat, INTERVAL_MS); };
    const sync = () => (active() && !stopped ? start() : pause());

    sync();
    document.addEventListener("visibilitychange", sync);
    window.addEventListener("online", sync);
    window.addEventListener("offline", sync);
    return () => {
      stop();
      document.removeEventListener("visibilitychange", sync);
      window.removeEventListener("online", sync);
      window.removeEventListener("offline", sync);
    };
  }, [enabled]);
}
